import { List, LookupBase } from '@singularsystems/neo-core';
import DashboardEntityLookup from './DashboardEntityLookup';

export default class DashboardLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public byEntity = new List(DashboardEntityLookup);

    public hasHolidaysForYear : boolean = false;

    // Client only properties / methods

    public get hasNotices() {
        return !this.hasHolidaysForYear;
    }
}